/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverMetricAdjustmentAdminDto } from '../models/DriverMetricAdjustmentAdminDto';
import type { DriverMetricAdjustmentMetricType } from '../models/DriverMetricAdjustmentMetricType';
import type { DriverMetricAdjustmentStatus } from '../models/DriverMetricAdjustmentStatus';
import type { Pagination1OfDriverMetricAdjustmentAdminDto } from '../models/Pagination1OfDriverMetricAdjustmentAdminDto';
import type { PostDriverAcceptanceMetricAdjustmentAdminRequest } from '../models/PostDriverAcceptanceMetricAdjustmentAdminRequest';
import type { PostDriverShiftAdherenceMetricAdjustmentAdminRequest } from '../models/PostDriverShiftAdherenceMetricAdjustmentAdminRequest';
import type { PostRevokeDriverMetricAdjustmentAdminRequest } from '../models/PostRevokeDriverMetricAdjustmentAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverMetricAdjustmentsService {
    /**
     * **Required Policy:** `ViewDriverMetricAdjustments`
     * @returns Pagination1OfDriverMetricAdjustmentAdminDto OK
     * @throws ApiError
     */
    public static getAdjustmentsAdmin({
        driverId,
        regionId,
        metricType,
        status,
        recordDate,
        page,
        limit,
    }: {
        driverId?: number,
        regionId?: number,
        metricType?: DriverMetricAdjustmentMetricType,
        status?: DriverMetricAdjustmentStatus,
        recordDate?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverMetricAdjustmentAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivermetricadjustments',
            query: {
                'driverId': driverId,
                'regionId': regionId,
                'metricType': metricType,
                'status': status,
                'recordDate': recordDate,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverMetricAdjustments`
     * @returns DriverMetricAdjustmentAdminDto OK
     * @throws ApiError
     */
    public static getAdjustmentAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverMetricAdjustmentAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivermetricadjustments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverMetricAdjustments`
     * @returns DriverMetricAdjustmentAdminDto OK
     * @throws ApiError
     */
    public static postAcceptanceAdjustmentAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverAcceptanceMetricAdjustmentAdminRequest,
    }): CancelablePromise<DriverMetricAdjustmentAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/drivermetricadjustments/acceptance-rate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverMetricAdjustments`
     * @returns DriverMetricAdjustmentAdminDto OK
     * @throws ApiError
     */
    public static postShiftAdherenceAdjustmentAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverShiftAdherenceMetricAdjustmentAdminRequest,
    }): CancelablePromise<DriverMetricAdjustmentAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/drivermetricadjustments/shift-adherence',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverMetricAdjustments`
     * @returns DriverMetricAdjustmentAdminDto OK
     * @throws ApiError
     */
    public static postRevokeAdjustmentAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostRevokeDriverMetricAdjustmentAdminRequest,
    }): CancelablePromise<DriverMetricAdjustmentAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/drivermetricadjustments/{id}/revoke',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
